<template>
    <div class="trust-pilot">
        <img class="trust-pilot--border" src="@/assets/images/decoration/flowers.svg" alt="Flowers Image">
        <div class="trust-pilot--widget">
            <div ref="trustBoxRef" class="trustpilot-widget" data-locale="en-GB" data-template-id="53aa8807dec7e10d38f59f32" data-businessunit-id="596ca0ad0000ff0005a6d68d" data-style-height="82px" data-style-width="131px" data-theme="light">
                <a href="https://uk.trustpilot.com/review/www.freddiesflowers.com" target="_blank" rel="noopener"></a>
            </div>
        </div>
        <div class="trust-pilot--comment">
            <p class="trust-pilot--comment--text">"{{ getCommentText }}"</p>
            <p class="trust-pilot--comment--foot">{{ `- ${getCommentAuthor}`}}</p>
        </div>
    </div>
</template>

<script>
import customerReviews from '@/content/customerTrustPilotReviews.json';

export default {
    name: 'AltTrustPilot',
    props: {
        step: {
            type: String,
            require: false,
            default: 'account',
        },
    },
    mounted() {
        window.Trustpilot.loadFromElement(this.$refs.trustBoxRef, true);
    },
    computed: {
        getCommentText() {
            return customerReviews.registrationSteps[this.step].review;
        },
        getCommentDate() {
            return customerReviews.registrationSteps[this.step].date;
        },
        getCommentAuthor() {
            return customerReviews.registrationSteps[this.step].name;
        },
    },
};
</script>

<style lang="scss" scoped>
.trust-pilot {
    width: 113px;
    margin: 10px auto;
    padding: 30px;
    border: 1px solid #D9E6CD;
    position: relative;
    &--comment {
        padding: 0 20px;
        padding-top: 10px;
        &--text, &--foot {
            text-align: center;
            font-size: 15px;
            line-height: 20px;
            font-weight: 200;
        }
        &--foot {
            font-weight: 200;
        }
    }
    &--widget {
        width: fit-content;
        margin: 0 auto;
    }
    &--border {
        position: absolute;
        top: -40px;
        left: 35%;
        @media (min-width: 640px) {
            left: 40%;
        }
    }
}
</style>
